<template>
  <PageShell class="page-shell-wrapper--blog-list" locale="id" :page-title="pageTitle">
    <BlogListContent />
  </PageShell>
</template>

<script>
import PageShell from '@/components/layout/PageShell.vue';
import BlogListContent from './BlogListContent.vue';

export default {
  name: 'BlogListPage',
  components: { PageShell, BlogListContent },
  computed: {
    pageTitle() {
      return this.$route.meta.pageTitle || '';
    },
  },
};
</script>
